// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"PlotEditor_mainLayout__2CMv0","contentLayout":"PlotEditor_contentLayout__3hT29"};